import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ element: Element, ...rest }) => {
  const location = useLocation();

  const isLoggedIn = localStorage.getItem('isLoggedIn') === '1';

  if (isLoggedIn) {
    const expiresAt = localStorage.getItem('expiresAt');

    if (expiresAt) {
      const now = new Date().getTime();
      const expiresAtTimestamp = Number(expiresAt);

      if (expiresAtTimestamp <= now) {
        console.log('Token expired in PrivateRoute, cleaning up');
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('expiresAt');
        localStorage.removeItem('accessToken');

        localStorage.setItem('redirect', location.pathname + location.search);

        return <Navigate to='/login' replace />;
      }
    }
  }

  if (!isLoggedIn) {
    localStorage.setItem('redirect', location.pathname + location.search);
    return <Navigate to='/login' replace />;
  }
  return <Element {...rest} />;
};

PrivateRoute.propTypes = {
  element: PropTypes.elementType.isRequired,
};

export default PrivateRoute;
